function Condition() {
  return (
    <div className="conditon section">
      <h2 className="title">
        <img src="images/yodogawa-5.png" alt="参加条件" />
      </h2>

      <h3>対象</h3>
      <p>
        観光客と接する機会のある方、
        <br />
        観光に興味のある方
      </p>

      <h3>定員</h3>
      <p className="emp">30名</p>
      <p className="hosoku">（参加者多数の場合、抽選とさせていただきます）</p>
    </div>
  );
}

export default Condition;
